// pages/Terms.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import FAQTab from '../components/FAQTab';
import LegalTab from '../components/LegalTab';
import Cookies from 'js-cookie';
import TABnavigation from '../components/TABnavigation';
import RedirectButton from './RedirectButton';

const Terms = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('faq');

  const redirectURL = localStorage.getItem('redirectUrl');
const navigateHandler = () => {
     const redirectURL = localStorage.getItem('redirectUrl');
    // console.log("userId in age group",getCookie("userId"))
    if (redirectURL) {
    window.location.href = redirectURL;
  } else {
    // console.log("No redirect URL found");
  }
  };

  const navigateToTerms = ()=>{
    navigate('/termsandconditions')
  }
  return (
    <div className="h-screen bg-gradient-to-b from-[#253246] to-[#1e2738] flex justify-center items-center overflow-hidden">
      <div className="w-full max-w-[390px] h-full flex flex-col">

        {/* Header */}
        <div className="px-6 py-6 flex items-center justify-center relative flex-shrink-0">
          <button
            onClick={() => navigate('/profile')}
            className="absolute left-6 bg-transparent border-2 border-white rounded-lg cursor-pointer w-10 h-10 flex items-center justify-center text-white"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <h1 className="text-2xl font-normal text-white">
            Ts & Cs & FAQs
          </h1>
        </div>

        {/* Tabs */}
        <div className="px-6 flex-shrink-0">
          <div className="flex justify-center gap-8 border-b border-gray-700 relative">
            {['faq', 'legal'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`pb-3 text-lg font-medium transition-colors relative ${
                  activeTab === tab ? 'text-[#00D9FF]' : 'text-gray-400'
                }`}
              >
                {tab === 'faq' ? 'FAQ' : 'Legal & Privacy'}
                {activeTab === tab && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#00D9FF]" />
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="flex-1 overflow-y-auto py-2">
          {activeTab === 'faq' ? <FAQTab /> : <LegalTab />}
        </div>

        {/* Bottom Buttons */}
        <div className="px-6 mb-16 py-2 flex flex-col gap-3 flex-shrink-0">
          <RedirectButton />
           <TABnavigation navHandeler={navigateHandler}/>
        </div>

      </div>
    </div>
  );
};

export default Terms;